var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGliderHeading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.17 100.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #231f20;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #314a70;\r\n        stroke: #fff;\r\n        stroke-width: 4px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "43.24 17.76 33.56 17.76 38.4 9.38 43.24 1 48.08 9.38 52.91 17.76 43.24 17.76"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 42.58,
    cy: 58,
    r: 40.58
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.73,
    y: 34.55,
    width: 3.73,
    height: 42.02,
    rx: 1.86,
    ry: 1.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "67.15 59.31 42.58 56.69 42.58 48.17 67.15 53.95 67.15 59.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.02 59.31 42.59 56.61 42.59 48.17 18.02 53.95 18.02 59.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.92 81.44 42.57 78.26 42.57 70.3 49.92 76.08 49.92 81.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.22 81.44 42.57 78.25 42.57 70.3 35.22 76.08 35.22 81.44"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGliderHeading);
export default __webpack_public_path__ + "static/media/glider-heading.80e207d22aea81ff77bb35e46645da68.svg";
export { ForwardRef as ReactComponent };